

const getters = {
    tenants: (state) => state.tenants,
    tenantsId: (state) => state.tenantsId,
    tenantFields:(state)=>state.tenantFields,
    logs:(state) => state.logs,
    configs:(state) => state.configs,
    signature: (state) => state.signature,
    id: (state) => state.id,
    loading: state => state.loading,
    loadingModule: (state) => state.loadingModule,
    moduletype: (state) => state.moduletype
};

export default getters;